import { render, staticRenderFns } from "./advConfiguration.vue?vue&type=template&id=59aa5b6a&scoped=true&"
import script from "./advConfiguration.vue?vue&type=script&lang=js&"
export * from "./advConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./advConfiguration.vue?vue&type=style&index=0&id=59aa5b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aa5b6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59aa5b6a')) {
      api.createRecord('59aa5b6a', component.options)
    } else {
      api.reload('59aa5b6a', component.options)
    }
    module.hot.accept("./advConfiguration.vue?vue&type=template&id=59aa5b6a&scoped=true&", function () {
      api.rerender('59aa5b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/advConfiguration.vue"
export default component.exports